/**
 *
 * @deprecated - legacy code used only in old parts of the app
 */
export const set = (
  // eslint-disable-next-line
  obj: any,
  path: Array<string | number>,
  // eslint-disable-next-line
  value: any,
  onlyIfEmpty: boolean
) => {
  let cursor = obj;
  for (const p of path.slice(0, -1)) {
    if (!cursor[p]) {
      cursor[p] = {};
    }
    cursor = cursor[p];
  }
  if (onlyIfEmpty) {
    if (!cursor[path[path.length - 1]]) {
      cursor[path[path.length - 1]] = value;
    }
  } else {
    cursor[path[path.length - 1]] = value;
  }
};
